if (!customElements.get('slideshow-swiper')) {
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    /**
     * 使用透明导航栏
     */
    useTransparentHeader;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
    }

    connectedCallback() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        // effect: 'fade',
        loop: this.sectionSettings.loop,
        autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
          delay: this.sectionSettings.autoplay_speed * 1000,
          pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        },
        autoHeight: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: `#${this.id} .swiper-btn-next`,
          prevEl: `#${this.id} .swiper-btn-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        on: {
          slideChange: this.handleSlideChange.bind(this)
        },
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }

      this.useTransparentHeader = this.sectionSettings.use_transparent_header;
      if (this.useTransparentHeader) {
        document.body.setAttribute("data-immersive", "dark");
      }

      this.handleSlideChange();
      // const resizeObserver = new ResizeObserver((entries) => this.updateHeight());
      // resizeObserver.observe(document.body);
    }

    handleSlideChange() {
      if (!this.mySwiper) return;
      // 切换 Slide 时，更新导航栏的配色
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      const brightness = slide.getAttribute("data-brightness");
      if (this.useTransparentHeader) {
        if (document.body?.hasAttribute("data-immersive")) {
          document.body.setAttribute("data-immersive", brightness);
        }
      }
      // 更新模块高度
      // this.updateHeight();
    }

    /**
     * 更新模块高度
     */
    updateHeight() {
      if (!this.mySwiper) return;
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      this.style.height = slide.clientHeight - 1 + "px";
    }
  }

  customElements.define('slideshow-swiper', SlideshowSwiper);
}